<template>
    <section :class="styleMain">
      <el-tabs v-model="state" :stretch="true" v-if="match">
        <el-tab-pane label="Tout" name="0">
          <status-period :match="match"/>
        </el-tab-pane>
        <el-tab-pane v-for="item in statuses" :key="item.id" :label="item.shortname" :name="item.id.toString()">
          <status-period :match="match" :statusId="item.id"/>
        </el-tab-pane>
      </el-tabs>
      <status-settings :match="match" />
    </section>
</template>

<script>
import StatusPeriod from './status/StatusPeriod'
import StatusSettings from './status/StatusSettings'
import { status } from '@/store/model/sport/football/Status'

export default {
  name: 'SportFootballMatchStatus',
  props: {
    match: Object
  },
  components: { StatusPeriod, StatusSettings },
  data () {
    return {
      statusLocal: null
    }
  },
  computed: {
    state: {
      get () { return this.statusLocal || this.defaultTab },
      set (value) {
        value = parseInt(value)
        value = value > 0 ? value : null
        this.$emit('statusfilter', value)
      }
    },
    statuses () { return status.actions },
    defaultTab () { return this.match?.id ? status.defaultTab(this.match.statusId)?.toString() : '0' },
    styleMain () { return ['sportFootballMatchStatus', this.styleLoaded] }
  },
  updated () {
    this.styleLoaded = 'loaded'
  }
}
</script>

<style>
.sportFootballMatchStatus{
  position:relative;
  flex:initial;
  height:90px;
  width:auto;
  background-color:white;
  transition-duration: 1s;
  transition-property: opacity;

  /* opacity: 0; */
}
.sportFootballMatchStatus.loaded{
  opacity: 1;
}
.sportFootballMatchStatus .el-tab-pane{
  height:60px
}
.sportFootballMatchStatus .el-tabs__item{
  color: var(--color-font-grey-light);
  font-weight:bold;
  box-sizing: border-box;
  line-height:30px;
  height:30px;
  border-width:3px 1px 0 1px;
  border-color: transparent;
  border-style:solid;
}
.sportFootballMatchStatus .el-tabs__item.is-active{
  border-color: black var(--color-background-grey-dark) white var(--color-background-grey-dark);
  border-width:3px 1px 2px 1px;
  color: black;
}
.sportFootballMatchStatus .el-tabs__active-bar{
  display: none
}
.sportFootballMatchStatus .el-tabs__header{
  margin-bottom:0
}
</style>
